import MonthlyReportingView from "./MonthlyReportingView";

export default MonthlyReportingView;
